const SubscriptionPayments = ({
    subscriptionDetails = {},
    payments = []
}) => {
   
	const pricing_amount = process.env.REACT_APP_STRIPE_MONTHLY_PRICING;
    return (
        <div className="mjs-dash-section">
            <div className="mjs-dash-sec-header"><h4>Payment Details</h4></div>
            <div className="mjs-dash-inner-container">
                <h5>Upcoming Payment</h5>
                <div className="mjs-dash-row">
                    <span>Amount</span>
                    <span>${(Number(subscriptionDetails.amount || {pricing_amount})).toFixed(2)}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Due Date</span>
                    <span>
                        {subscriptionDetails?.paused && <i title="Uncollectible" style={{color: "red"}} class="fa-solid fa-circle-exclamation"></i>}
                        {" "}
                        {subscriptionDetails.currentPeriodEnd
                            ? new Date(subscriptionDetails.currentPeriodEnd).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            })
                            : "—"}
                    </span>
                </div>
            </div>
            <div className="mjs-dash-inner-container">
                <h5>Payment History</h5>
                <table className="mjs-table">
                    <thead>
                        <tr>
                            <th>Site Name</th>
                            <th>Amount($)</th>
                            <th>Payment Method</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th></th>
                        </tr>
                    </thead>

                    {payments.length > 0 ? (
                        <tbody>
                            {payments.map((payment) => (
                                <tr key={payment.id}>                                    
                                    <td>{payment.siteName || "-"}</td>
                                    <td>{payment.amount || "--"}</td>
                                    <td>{payment.methodDetail || "-"}</td>
                                    <td>{payment.status === 'paid' ? 'paid' : "failed"}</td>
                                    <td>
                                        {payment.created
                                            ? new Date(
                                                  payment.created * 1000
                                              ).toDateString()
                                            : "—"}
                                    </td>   
                                    {payment.status === 'open' &&
                                        <td className="mjs-table-actions">
                                            <button
                                                className='mjs-btn'
                                                onClick={() => {
                                                    if (payment.hosted_url) {
                                                        window.open(payment.hosted_url, "_blank", "noopener,noreferrer");
                                                    }
                                                }}
                                            >Retry</button>
                                        </td>
                                    }                                 
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td colSpan="8" className="mjs-msg">
                                    No Payments found.
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div> 
    );
};

export default SubscriptionPayments;
